import { INVOICES } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";
import { getEntity } from "../../actions/actionUtils.js";

export const getInvoice = (id, options) => {
  return getEntity(INVOICES, id, options);
};

export const getInvoices = (searchParams, options) => {
  return {
    type: INVOICES.GET,
    payload: {
      endpoint: `${ENDPOINTS.INVOICES}${searchParams || ""}`
    },
    options
  };
};
